export const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
};

export const DEFAULTS = {
  enabled: true,
  logLevel: LOG_LEVELS.DEBUG,
  separator: '|',
};

function initInstance(options, levels) {
  const logger = {};
  levels.forEach((logLevel) => {
    if (options.enabled && levels.indexOf(logLevel) >= levels.indexOf(options.logLevel)) {
      logger[logLevel] = (...args) => {
        const prefix = `${logLevel} ${options.separator} `;

        // eslint-disable-next-line no-console
        console[logLevel](prefix, ...args);

        const message = `${prefix}${args.toString()}`;

        return message;
      };
    } else {
      logger[logLevel] = () => undefined;
    }
  });
  return logger;
}

function install(app, options) {
  install.instance = initInstance({ ...DEFAULTS, ...options }, Object.values(LOG_LEVELS));
  app.config.globalProperties.$log = install.instance;
  // Make it available globally as well
  app.provide('$log', install.instance);
}

export const logger = Object.values(LOG_LEVELS).reduce((acc, level) => {
  acc[level] = (...args) => install.instance[level](...args);
  return acc;
}, {});

export default {
  install,
};
